import React from 'react';

export default function Toast({ toast }) {
  if (!toast) return null;
  const tone = toast.tone === 'error' ? 'bg-red-600' : 'bg-green-600';
  return (
    <div
      className={`fixed right-5 top-5 z-[60] rounded-md px-4 py-2.5 text-sm text-white shadow-lg ${tone}`}
    >
      {toast.message}
    </div>
  );
}
